'use strict';

angular.module('amexReconciliationApp')
  .service('AccountListService', function (TransactionSearchModel, $state) {
    var self = this;

    self.getLockStatusToolTip = function (billingCycle) {
      var lockStatus = billingCycle.lockStatus;

      switch(lockStatus) {
        case 'FULLY_LOCKED':
          return 'lockStatus.fullyLockedTooltip';
        case 'PARTIALLY_LOCKED':
          return 'lockStatus.partiallyLockedTooltip';
        case 'MIXED_LOCK':
          return 'lockStatus.mixedLockTooltip';
        default:
          return '';
      }
    };

    self.getLockColor = function(billingCycle) {
      var lockStatus = billingCycle.lockStatus;

      switch(lockStatus) {
        case 'FULLY_LOCKED':
          return 'warning-font';
        case 'PARTIALLY_LOCKED':
          return 'success-font';
        case 'MIXED_LOCK':
          return 'black-font';
        default:
          return '';
      }
    };

    self.showLockIcon = function (billingCycle) {
      if(billingCycle) {
        return billingCycle.lockStatus !== 'UNLOCKED';
      }
      return false;
    };

    self.roleChange = function (role) {
      TransactionSearchModel.role(role);
      if(TransactionSearchModel.isBcaManager()) {
        $state.go('bcaManager');
      } else if(TransactionSearchModel.isCardManager()){
        $state.go('cardManager');
      } else if(TransactionSearchModel.isAccountingManager()){
        $state.go('accountingManager');
      } else if(TransactionSearchModel.isCardMember()) {
        $state.go('cardmember');
      } else if(TransactionSearchModel.isBtaManager()) {
        $state.go('btaManager');
      } else {
        $state.go('home');
      }
    };

  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/services/AccountListService.js
// module id = 631
// module chunks = 0